module.exports = __webpack_public_path__ + "static/media/errorHint.1e7725c8.svg";